export const metaDataTaskAssigneeType = {
  MEMBER: 'User',
  TEAM: 'TeamGroup',
  CONTACT: 'Contact'
}

export const typeFileQuickSelectOptions = {
  PROJECT: 'Project',
  PLAN: 'Plan',
  FOLDER: 'Folder'
}
export const GlobalSearchTabOptions = {
  PINS: 'pins',
  TASKS: 'tasks',
  PLANS: 'plans'
}

// mock
export const PINS = [
  {
    createdBy: {
      id: '4e8313a9-7b66-45ca-b499-8b9dcc4185b2',
      name: 'Wolfgang Niel'
    },
    created: '2025-10-24T08:21:54.838Z',
    lastModifiedBy: {
      id: '4e8313a9-7b66-45ca-b499-8b9dcc4185b2',
      name: 'Wolfgang Niel'
    },
    lastModified: '2025-10-24T08:27:38.385Z',
    id: 'f750f542-d127-4f09-8116-d455f92c699d',
    projectId: 'a842d2b9-becb-4559-bbd2-a5c153c1fe57',
    number: 615,
    title: 'Fenster tauschen',
    description: '',
    category: {
      created: '2022-03-15T14:01:23.938Z',
      lastModified: '2022-03-15T14:01:23.938Z',
      categoryId: '6a0cb4d5-4967-4c36-81f9-edb083865c9d',
      name: 'General',
      color: 'DarkBlue',
      active: true,
      orderNumber: 0,
      defaultCategory: false
    },
    priority: 0,
    costs: 0,
    coords: {},
    tags: ['high'],
    fieldValues: {
      '1676419a-b275-4577-90ee-42fbbd4ab760': '2025-10-24T10:25:00.000',
      '24fd5760-f7a9-40af-9c1a-8cb02f913d63': 500,
      '3b933d05-308a-4174-b71e-3a9926e064a6': 3,
      '3dc015ae-7444-4c6a-927f-b42a771794c0': ['high'],
      '71a031b1-9838-4578-9469-6d5c6af66db6': 75360,
      '7eeec06d-d125-478a-a96c-e18941e9b895': '2025-10-30T10:24:00.000',
      'a832ff34-7c7d-4616-a797-97f6203f98f5':
        'unusually what time is your flight ',
      'da03059d-ffd0-4524-8c68-10e8ee0a5812': 1,
      'fea269c1-08a4-4589-bc59-04ae5f2e8f87': 1
    },
    state: 'Open',
    groups: [],
    linkedRecords: [],
    progress: {
      tasksDone: 0,
      totalTasks: 1,
      tasksClosed: 0,
      indicator: 'None',
      indicatorCurrent: 'Open',
      percent: 0
    },
    permissions: ['Edit', 'ViewHistory'],
    planReference: {
      planId: '37b07175-96dd-4b8d-9cba-f3efb77de879',
      planName:
        '2020-12-07-509.591_Schloss_Berlin_Aufmaß-U1M440_GR004-2J-G-603',
      planFileName:
        '2020-12-07-509.591_Schloss_Berlin_Aufmaß-U1M440_GR004-2J-G-603.pdf',
      revisionId: 'a8d6d5cc-0a08-48a9-9e82-92d99406046e',
      x: 11904,
      y: 7168,
      active: true,
      objectIds: [],
      cameraSettings: '',
      modelView: ''
    },
    location: {
      id: 'f750f542-d127-4f09-8116-d455f92c699d',
      x: 11904,
      y: 7168,
      color: 'DarkBlue',
      indicator: 'None',
      indicatorCurrent: 'Open',
      progress: 0,
      totalTasks: 1,
      state: 'Open',
      lastModified: '2025-10-24T08:27:38.385Z',
      number: 615,
      title: 'Fenster tauschen'
    },
    syncLastModified: '2025-10-24T08:27:39.758Z'
  },
  {
    createdBy: {
      id: 'acd41724-b1f1-4df6-b338-377873fd9e70',
      name: 'Yana Avramova'
    },
    created: '2023-12-21T12:49:39.189Z',
    lastModifiedBy: {
      id: 'acd41724-b1f1-4df6-b338-377873fd9e70',
      name: 'Yana Avramova'
    },
    lastModified: '2025-09-15T15:53:26.924Z',
    id: 'e084feb1-b968-490e-b417-b6515bc946a1',
    projectId: 'a842d2b9-becb-4559-bbd2-a5c153c1fe57',
    number: 227,
    title: 'Template Tags',
    description: '',
    category: {
      created: '2023-11-30T07:24:03.705Z',
      lastModified: '2023-11-30T07:24:03.705Z',
      categoryId: 'f3b19407-86fe-4213-baed-ccad92f316ce',
      name: 'Information',
      color: 'Pink',
      active: true,
      orderNumber: 1,
      defaultCategory: false
    },
    priority: 0,
    costs: 0,
    coords: {},
    tags: ['TestTagTemplate1', 'ChangeTagT1'],
    fieldValues: {
      '3dc015ae-7444-4c6a-927f-b42a771794c0': [
        'TestTagTemplate1',
        'ChangeTagT1'
      ],
      '71a031b1-9838-4578-9469-6d5c6af66db6': 0
    },
    state: 'Open',
    groups: [],
    linkedRecords: [],
    progress: {
      tasksDone: 0,
      totalTasks: 6,
      tasksClosed: 0,
      indicator: 'None',
      indicatorCurrent: 'Open',
      percent: 0
    },
    permissions: ['Edit', 'ViewHistory'],
    planReference: {
      planId: '7cb105a0-80a3-4c02-9fdd-521eb7c84f92',
      planName: '2b9c5aee-8aad-48e1-a245-444bf9168eae',
      planFileName: '2b9c5aee-8aad-48e1-a245-444bf9168eae.jpeg',
      revisionId: '9f7737b5-4512-428f-b7f7-f115ad2b1be6',
      x: 113,
      y: 1579,
      active: true,
      objectIds: [],
      cameraSettings: '',
      modelView: ''
    },
    location: {
      id: 'e084feb1-b968-490e-b417-b6515bc946a1',
      x: 113,
      y: 1579,
      color: 'Pink',
      indicator: 'None',
      indicatorCurrent: 'Open',
      progress: 0,
      totalTasks: 6,
      state: 'Open',
      lastModified: '2025-09-15T15:53:26.924Z',
      number: 227,
      title: 'Template Tags'
    },
    syncLastModified: '2025-09-15T15:53:27.330Z',
    owningGroup: {
      id: 'b1db22f3-18f1-4d5d-95db-9263e2f8f18d',
      name: 'Contributors'
    }
  },
  {
    createdBy: {
      id: 'acd41724-b1f1-4df6-b338-377873fd9e70',
      name: 'Yana Avramova'
    },
    created: '2024-02-15T08:54:53.136Z',
    lastModifiedBy: {
      id: 'acd41724-b1f1-4df6-b338-377873fd9e70',
      name: 'Yana Avramova'
    },
    lastModified: '2025-09-15T15:54:24.174Z',
    id: '0571e5d9-8c22-442b-a193-491cc98d0f06',
    projectId: 'a842d2b9-becb-4559-bbd2-a5c153c1fe57',
    number: 350,
    title: 'New',
    description: '',
    category: {
      created: '2023-11-30T07:24:03.705Z',
      lastModified: '2023-11-30T07:24:03.705Z',
      categoryId: 'f3b19407-86fe-4213-baed-ccad92f316ce',
      name: 'Information',
      color: 'Pink',
      active: true,
      orderNumber: 1,
      defaultCategory: false
    },
    priority: 0,
    costs: 0,
    coords: {},
    tags: [],
    fieldValues: {},
    state: 'Open',
    groups: [],
    linkedRecords: [],
    progress: {
      tasksDone: 0,
      totalTasks: 6,
      tasksClosed: 0,
      indicator: 'None',
      indicatorCurrent: 'Open',
      percent: 0
    },
    permissions: ['Edit', 'ViewHistory'],
    planReference: {
      planId: 'e5417491-6389-43cb-a8cc-188912f4d43a',
      planName: 'Erdgeschoss copy',
      planFileName: 'Erdgeschoss copy.pdf',
      revisionId: '851aeac1-58c9-4b65-a583-91bf4a22cced',
      x: 972,
      y: 872,
      active: true,
      objectIds: [],
      cameraSettings: '',
      modelView: ''
    },
    location: {
      id: '0571e5d9-8c22-442b-a193-491cc98d0f06',
      x: 972,
      y: 872,
      color: 'Pink',
      indicator: 'None',
      indicatorCurrent: 'Open',
      progress: 0,
      totalTasks: 6,
      state: 'Open',
      lastModified: '2025-09-15T15:54:24.174Z',
      number: 350,
      title: 'New'
    },
    syncLastModified: '2025-09-15T15:54:24.662Z',
    owningGroup: {
      id: 'b1db22f3-18f1-4d5d-95db-9263e2f8f18d',
      name: 'Contributors'
    }
  },
  {
    createdBy: {
      id: 'acd41724-b1f1-4df6-b338-377873fd9e70',
      name: 'Yana Avramova'
    },
    created: '2023-11-23T16:23:15.697Z',
    lastModifiedBy: {
      id: 'acd41724-b1f1-4df6-b338-377873fd9e70',
      name: 'Yana Avramova'
    },
    lastModified: '2025-09-15T15:53:15.437Z',
    id: '1250dd3c-c46d-4e43-ac9f-98832f9dd2f5',
    projectId: 'a842d2b9-becb-4559-bbd2-a5c153c1fe57',
    number: 200,
    title: 'Pin',
    description: '',
    category: {
      created: '2023-11-30T07:24:03.705Z',
      lastModified: '2023-11-30T07:24:03.705Z',
      categoryId: 'f3b19407-86fe-4213-baed-ccad92f316ce',
      name: 'Information',
      color: 'Pink',
      active: true,
      orderNumber: 1,
      defaultCategory: false
    },
    priority: 0,
    costs: 0,
    coords: {},
    tags: [],
    fieldValues: {
      '71a031b1-9838-4578-9469-6d5c6af66db6': 0
    },
    state: 'Open',
    groups: [],
    linkedRecords: [],
    progress: {
      tasksDone: 0,
      totalTasks: 3,
      tasksClosed: 0,
      indicator: 'None',
      indicatorCurrent: 'Open',
      percent: 0
    },
    permissions: ['Edit', 'ViewHistory'],
    planReference: {
      planId: 'df0966cb-d6fd-41d4-bf35-41173a7c7774',
      planName: '9e5c4526-ff58-4017-8b8b-a43c0cbcb495',
      planFileName: '9e5c4526-ff58-4017-8b8b-a43c0cbcb495.jpeg',
      revisionId: 'b2baf2ef-d639-4299-ae14-78b57039a255',
      x: 2115,
      y: 605,
      active: false,
      objectIds: [],
      cameraSettings: '',
      modelView: ''
    },
    location: {
      id: '1250dd3c-c46d-4e43-ac9f-98832f9dd2f5',
      x: 2115,
      y: 605,
      color: 'Pink',
      indicator: 'None',
      indicatorCurrent: 'Open',
      progress: 0,
      totalTasks: 3,
      state: 'Open',
      lastModified: '2025-09-15T15:53:15.437Z',
      number: 200,
      title: 'Pin'
    },
    syncLastModified: '2025-09-15T15:53:15.824Z',
    owningGroup: {
      id: 'b1db22f3-18f1-4d5d-95db-9263e2f8f18d',
      name: 'Contributors'
    }
  },
  {
    createdBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    created: '2025-06-27T12:43:21.557Z',
    lastModifiedBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    lastModified: '2025-10-16T16:19:24.666Z',
    id: '472ccd32-4cc7-400a-ab78-ab0296cc09f5',
    projectId: 'db189a81-2b86-42c8-8c27-9575b94dd231',
    number: 117,
    title: 'teste 1',
    description: '',
    category: {
      created: '2024-06-14T18:41:33.860Z',
      lastModified: '2024-06-14T18:41:33.860Z',
      categoryId: '1121e5bb-dd89-419a-ae09-616303978c26',
      name: 'teste 2',
      color: 'DarkBrown',
      active: true,
      orderNumber: 10,
      defaultCategory: false
    },
    priority: 0,
    costs: 0,
    coords: {},
    tags: [],
    fieldValues: {},
    state: 'Open',
    groups: [],
    linkedRecords: [
      {
        id: '173ec907-f8b2-4df3-909a-3c43d9d49386',
        dataSetId: '4b5dc741-27e3-40a0-a2bc-f3dc482cda5e',
        dataSetName: 'table-test',
        idColumnName: 'house number',
        idValue: 'big house',
        titleColumnName: 'name',
        titleValue: 'Danilo',
        record: {
          '5cd34faa-5844-4eca-afb3-22caf1f667b2': 'Danilo',
          '99596b74-4bc4-48e4-bf9d-19d12fb5d2ba': 'big house'
        },
        dataSetVersionId: 'a116034f-1ea0-4e8a-b905-19b480914b9f'
      }
    ],
    progress: {
      tasksDone: 0,
      totalTasks: 6,
      tasksClosed: 0,
      indicator: 'None',
      indicatorCurrent: 'Open',
      percent: 0
    },
    permissions: ['Edit', 'ViewHistory'],
    planReference: {
      planId: 'f90b1580-c935-4879-95a3-7e78a73e6f8d',
      planName: 'airoh',
      planFileName: 'airoh.jpeg',
      revisionId: '8940ef16-f8f5-40bc-a31c-2deff07ab416',
      x: 24,
      y: 519,
      active: true,
      objectIds: [],
      cameraSettings: '',
      modelView: ''
    },
    location: {
      id: '472ccd32-4cc7-400a-ab78-ab0296cc09f5',
      x: 24,
      y: 519,
      color: 'DarkBrown',
      indicator: 'None',
      indicatorCurrent: 'Open',
      progress: 0,
      totalTasks: 6,
      state: 'Open',
      lastModified: '2025-10-16T16:19:24.666Z',
      number: 117,
      title: 'teste 1'
    },
    syncLastModified: '2025-10-16T16:19:25.040Z'
  },
  {
    createdBy: {
      id: 'f579379b-1d64-405f-a0cd-9cd90ebe2763',
      name: 'Jose Pinto'
    },
    created: '2024-07-23T21:43:59.954Z',
    lastModifiedBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    lastModified: '2025-10-16T16:19:04.456Z',
    id: 'bcba98d3-ac53-4c6b-82e9-272920fcfc6d',
    projectId: 'db189a81-2b86-42c8-8c27-9575b94dd231',
    number: 38,
    title: 'teste 1',
    description: '',
    category: {
      created: '2023-12-01T14:17:13.783Z',
      lastModified: '2023-12-01T14:17:13.783Z',
      categoryId: '1fe39c15-b30f-4d9a-884f-2c70552e83ef',
      name: 'Defecta',
      color: 'Red',
      active: true,
      orderNumber: 2,
      defaultCategory: false
    },
    priority: 0,
    costs: 0,
    coords: {},
    tags: [],
    fieldValues: {},
    state: 'Open',
    groups: [],
    linkedRecords: [
      {
        id: '173ec907-f8b2-4df3-909a-3c43d9d49386',
        dataSetId: '4b5dc741-27e3-40a0-a2bc-f3dc482cda5e',
        dataSetName: 'table-test',
        idColumnName: 'house number',
        idValue: 'big house',
        titleColumnName: 'name',
        titleValue: 'Danilo',
        record: {
          '5cd34faa-5844-4eca-afb3-22caf1f667b2': 'Danilo',
          '99596b74-4bc4-48e4-bf9d-19d12fb5d2ba': 'big house'
        },
        dataSetVersionId: 'a116034f-1ea0-4e8a-b905-19b480914b9f'
      }
    ],
    progress: {
      tasksDone: 0,
      totalTasks: 6,
      tasksClosed: 0,
      indicator: 'OverdueOrRejected',
      indicatorCurrent: 'Due',
      percent: 0
    },
    permissions: ['Edit', 'ViewHistory'],
    planReference: {
      planId: 'e811f5a4-d6ab-42c4-b56b-5d8e2c51d502',
      planName: 'Airoh with Pinssss',
      planFileName: 'airoh1 copy.jpeg',
      revisionId: '4509c991-0ef8-4a83-b9e9-8234bd4dee9c',
      x: 766,
      y: 572,
      active: true,
      objectIds: [],
      cameraSettings: '',
      modelView: ''
    },
    location: {
      id: 'bcba98d3-ac53-4c6b-82e9-272920fcfc6d',
      x: 766,
      y: 572,
      color: 'Red',
      indicator: 'OverdueOrRejected',
      indicatorCurrent: 'Due',
      progress: 0,
      totalTasks: 6,
      state: 'Open',
      lastModified: '2025-10-16T16:19:04.456Z',
      number: 38,
      title: 'teste 1'
    },
    syncLastModified: '2025-10-16T16:19:04.700Z'
  },
  {
    createdBy: {
      id: 'f579379b-1d64-405f-a0cd-9cd90ebe2763',
      name: 'Jose Pinto'
    },
    created: '2024-07-23T22:04:45.280Z',
    lastModifiedBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    lastModified: '2025-10-16T16:19:04.846Z',
    id: '586c2077-c9dc-48ac-86b1-78a9a572fa88',
    projectId: 'db189a81-2b86-42c8-8c27-9575b94dd231',
    number: 40,
    title: 'teste 1',
    description: '',
    category: {
      created: '2023-12-01T14:17:13.783Z',
      lastModified: '2023-12-01T14:17:13.783Z',
      categoryId: '1fe39c15-b30f-4d9a-884f-2c70552e83ef',
      name: 'Defecta',
      color: 'Red',
      active: true,
      orderNumber: 2,
      defaultCategory: false
    },
    priority: 0,
    costs: 0,
    coords: {},
    tags: [],
    fieldValues: {},
    state: 'Open',
    groups: [],
    linkedRecords: [
      {
        id: '173ec907-f8b2-4df3-909a-3c43d9d49386',
        dataSetId: '4b5dc741-27e3-40a0-a2bc-f3dc482cda5e',
        dataSetName: 'table-test',
        idColumnName: 'house number',
        idValue: 'big house',
        titleColumnName: 'name',
        titleValue: 'Danilo',
        record: {
          '5cd34faa-5844-4eca-afb3-22caf1f667b2': 'Danilo',
          '99596b74-4bc4-48e4-bf9d-19d12fb5d2ba': 'big house'
        },
        dataSetVersionId: 'a116034f-1ea0-4e8a-b905-19b480914b9f'
      }
    ],
    progress: {
      tasksDone: 0,
      totalTasks: 6,
      tasksClosed: 0,
      indicator: 'OverdueOrRejected',
      indicatorCurrent: 'Due',
      percent: 0
    },
    permissions: ['Edit', 'ViewHistory'],
    planReference: {
      planId: 'e811f5a4-d6ab-42c4-b56b-5d8e2c51d502',
      planName: 'Airoh with Pinssss',
      planFileName: 'airoh1 copy.jpeg',
      revisionId: '4509c991-0ef8-4a83-b9e9-8234bd4dee9c',
      x: 708,
      y: 610,
      active: true,
      objectIds: [],
      cameraSettings: '',
      modelView: ''
    },
    location: {
      id: '586c2077-c9dc-48ac-86b1-78a9a572fa88',
      x: 708,
      y: 610,
      color: 'Red',
      indicator: 'OverdueOrRejected',
      indicatorCurrent: 'Due',
      progress: 0,
      totalTasks: 6,
      state: 'Open',
      lastModified: '2025-10-16T16:19:04.846Z',
      number: 40,
      title: 'teste 1'
    },
    syncLastModified: '2025-10-16T16:19:05.109Z'
  },
  {
    createdBy: {
      id: 'f579379b-1d64-405f-a0cd-9cd90ebe2763',
      name: 'Jose Pinto'
    },
    created: '2025-01-31T21:33:49.123Z',
    lastModifiedBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    lastModified: '2025-10-16T16:19:21.042Z',
    id: 'c52f479e-8a68-427f-b177-278c687cd165',
    projectId: 'db189a81-2b86-42c8-8c27-9575b94dd231',
    number: 104,
    title: 'teste 1',
    description: '',
    category: {
      created: '2023-12-01T14:17:13.783Z',
      lastModified: '2023-12-01T14:17:13.783Z',
      categoryId: '1fe39c15-b30f-4d9a-884f-2c70552e83ef',
      name: 'Defecta',
      color: 'Red',
      active: true,
      orderNumber: 2,
      defaultCategory: false
    },
    priority: 0,
    costs: 0,
    coords: {},
    tags: [],
    fieldValues: {},
    state: 'Open',
    groups: [],
    linkedRecords: [
      {
        id: '173ec907-f8b2-4df3-909a-3c43d9d49386',
        dataSetId: '4b5dc741-27e3-40a0-a2bc-f3dc482cda5e',
        dataSetName: 'table-test',
        idColumnName: 'house number',
        idValue: 'big house',
        titleColumnName: 'name',
        titleValue: 'Danilo',
        record: {
          '5cd34faa-5844-4eca-afb3-22caf1f667b2': 'Danilo',
          '99596b74-4bc4-48e4-bf9d-19d12fb5d2ba': 'big house'
        },
        dataSetVersionId: 'a116034f-1ea0-4e8a-b905-19b480914b9f'
      }
    ],
    progress: {
      tasksDone: 0,
      totalTasks: 4,
      tasksClosed: 0,
      indicator: 'None',
      indicatorCurrent: 'Open',
      percent: 0
    },
    permissions: ['Edit', 'ViewHistory'],
    planReference: {
      planId: 'cdcf3e58-163d-4090-8c0b-d3693292a2ba',
      planName: 'media-frame (8)',
      planFileName: 'media-frame (8).png',
      revisionId: '9c6aaf55-0cc0-42e5-95cd-3214a66f29a8',
      x: 33,
      y: 104,
      active: true,
      objectIds: [],
      cameraSettings: '',
      modelView: ''
    },
    location: {
      id: 'c52f479e-8a68-427f-b177-278c687cd165',
      x: 33,
      y: 104,
      color: 'Red',
      indicator: 'None',
      indicatorCurrent: 'Open',
      progress: 0,
      totalTasks: 4,
      state: 'Open',
      lastModified: '2025-10-16T16:19:21.042Z',
      number: 104,
      title: 'teste 1'
    },
    syncLastModified: '2025-10-16T16:19:21.471Z'
  },
  {
    createdBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    created: '2025-08-29T18:08:09.636Z',
    lastModifiedBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    lastModified: '2025-10-16T16:19:25.768Z',
    id: 'ad991f3d-5dab-47e0-aafb-0d376fc54bfe',
    projectId: 'db189a81-2b86-42c8-8c27-9575b94dd231',
    number: 121,
    title: 'Pin 2',
    description: '',
    category: {
      created: '2023-12-01T14:17:13.783Z',
      lastModified: '2023-12-01T14:17:13.783Z',
      categoryId: '1fe39c15-b30f-4d9a-884f-2c70552e83ef',
      name: 'Defecta',
      color: 'Red',
      active: true,
      orderNumber: 2,
      defaultCategory: false
    },
    priority: 0,
    costs: 0,
    coords: {},
    tags: [],
    fieldValues: {},
    state: 'Open',
    groups: [],
    linkedRecords: [],
    progress: {
      tasksDone: 0,
      totalTasks: 5,
      tasksClosed: 0,
      indicator: 'None',
      indicatorCurrent: 'Open',
      percent: 0
    },
    permissions: ['Edit', 'ViewHistory'],
    planReference: {
      planId: 'd1e2df05-6de8-45c2-a096-2a7c01306168',
      planName: 'airoh1132123',
      planFileName: 'airoh1 copy.jpeg',
      revisionId: '0045ef69-22dd-45ab-abf4-34ca868c024e',
      x: 24,
      y: 394,
      active: true,
      objectIds: [],
      cameraSettings: '',
      modelView: ''
    },
    location: {
      id: 'ad991f3d-5dab-47e0-aafb-0d376fc54bfe',
      x: 24,
      y: 394,
      color: 'Red',
      indicator: 'None',
      indicatorCurrent: 'Open',
      progress: 0,
      totalTasks: 5,
      state: 'Open',
      lastModified: '2025-10-16T16:19:25.768Z',
      number: 121,
      title: 'Pin 2'
    },
    syncLastModified: '2025-10-16T16:19:26.220Z'
  },
  {
    createdBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    created: '2025-09-18T21:16:11.893Z',
    lastModifiedBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    lastModified: '2025-10-16T16:19:27.681Z',
    id: '90608f13-0632-4b40-8ef4-7eeda6154168',
    projectId: 'db189a81-2b86-42c8-8c27-9575b94dd231',
    number: 128,
    title: 'test pin close',
    description: '',
    category: {
      created: '2023-12-01T14:17:13.783Z',
      lastModified: '2023-12-01T14:17:13.783Z',
      categoryId: '1fe39c15-b30f-4d9a-884f-2c70552e83ef',
      name: 'Defecta',
      color: 'Red',
      active: true,
      orderNumber: 2,
      defaultCategory: false
    },
    priority: 0,
    costs: 0,
    coords: {},
    tags: [],
    fieldValues: {},
    state: 'Open',
    groups: [],
    linkedRecords: [],
    progress: {
      tasksDone: 0,
      totalTasks: 3,
      tasksClosed: 0,
      indicator: 'None',
      indicatorCurrent: 'Open',
      percent: 0
    },
    permissions: ['Edit', 'ViewHistory'],
    planReference: {
      planId: 'd1e2df05-6de8-45c2-a096-2a7c01306168',
      planName: 'airoh1132123',
      planFileName: 'airoh1 copy.jpeg',
      revisionId: '0045ef69-22dd-45ab-abf4-34ca868c024e',
      x: 19,
      y: 444,
      active: true,
      objectIds: [],
      cameraSettings: '',
      modelView: ''
    },
    location: {
      id: '90608f13-0632-4b40-8ef4-7eeda6154168',
      x: 19,
      y: 444,
      color: 'Red',
      indicator: 'None',
      indicatorCurrent: 'Open',
      progress: 0,
      totalTasks: 3,
      state: 'Open',
      lastModified: '2025-10-16T16:19:27.681Z',
      number: 128,
      title: 'test pin close'
    },
    syncLastModified: '2025-10-16T16:19:28.047Z'
  },
  {
    createdBy: {
      id: 'c088c75a-1c39-4658-99ef-03ace12a75b6',
      name: 'Jerry Contributor'
    },
    created: '2025-09-19T12:12:05.382Z',
    lastModifiedBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    lastModified: '2025-10-16T16:19:27.937Z',
    id: 'bf820f2c-c352-4391-83d8-91d2a0f8f8d1',
    projectId: 'db189a81-2b86-42c8-8c27-9575b94dd231',
    number: 129,
    title: 'pin test',
    description: '',
    category: {
      created: '2023-12-01T14:17:13.783Z',
      lastModified: '2023-12-01T14:17:13.783Z',
      categoryId: '1fe39c15-b30f-4d9a-884f-2c70552e83ef',
      name: 'Defecta',
      color: 'Red',
      active: true,
      orderNumber: 2,
      defaultCategory: false
    },
    priority: 0,
    costs: 0,
    coords: {},
    tags: [],
    fieldValues: {},
    state: 'Open',
    groups: [],
    linkedRecords: [],
    progress: {
      tasksDone: 0,
      totalTasks: 4,
      tasksClosed: 0,
      indicator: 'None',
      indicatorCurrent: 'Open',
      percent: 0
    },
    permissions: ['Edit', 'ViewHistory'],
    planReference: {
      planId: '5dfa3b2a-f77d-4f70-9b26-3f7bd6d123b0',
      planName: 'house-plan-test',
      planFileName: '1920x1080 2.jpg',
      revisionId: '1e5832b5-af91-4657-943c-891c67c01195',
      x: 44,
      y: 119,
      active: true,
      objectIds: [],
      cameraSettings: '',
      modelView: ''
    },
    location: {
      id: 'bf820f2c-c352-4391-83d8-91d2a0f8f8d1',
      x: 44,
      y: 119,
      color: 'Red',
      indicator: 'None',
      indicatorCurrent: 'Open',
      progress: 0,
      totalTasks: 4,
      state: 'Open',
      lastModified: '2025-10-16T16:19:27.937Z',
      number: 129,
      title: 'pin test'
    },
    syncLastModified: '2025-10-16T16:19:28.279Z'
  },
  {
    createdBy: {
      id: 'f579379b-1d64-405f-a0cd-9cd90ebe2763',
      name: 'Jose Pinto'
    },
    created: '2025-09-23T17:03:38.872Z',
    lastModifiedBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    lastModified: '2025-10-16T16:19:30.779Z',
    id: '8784d0c2-ea22-4cff-9bda-91c3a7986e57',
    projectId: 'db189a81-2b86-42c8-8c27-9575b94dd231',
    number: 140,
    title: 'Pin 1',
    description: '',
    category: {
      created: '2023-12-01T14:17:13.783Z',
      lastModified: '2023-12-01T14:17:13.783Z',
      categoryId: '1fe39c15-b30f-4d9a-884f-2c70552e83ef',
      name: 'Defecta',
      color: 'Red',
      active: true,
      orderNumber: 2,
      defaultCategory: false
    },
    priority: 0,
    costs: 0,
    coords: {},
    tags: [],
    fieldValues: {},
    state: 'Open',
    groups: [],
    linkedRecords: [],
    progress: {
      tasksDone: 0,
      totalTasks: 3,
      tasksClosed: 0,
      indicator: 'None',
      indicatorCurrent: 'Open',
      percent: 0
    },
    permissions: ['Edit', 'ViewHistory'],
    planReference: {
      planId: '26408799-67a5-4f28-b797-12059b43a10f',
      planName: 'DANFEEE',
      planFileName: 'effort.png',
      revisionId: 'a12a12f6-c507-4047-bd92-aae4b83f1c71',
      x: 0,
      y: 3360,
      active: true,
      objectIds: [],
      cameraSettings: '',
      modelView: ''
    },
    location: {
      id: '8784d0c2-ea22-4cff-9bda-91c3a7986e57',
      x: 0,
      y: 3360,
      color: 'Red',
      indicator: 'None',
      indicatorCurrent: 'Open',
      progress: 0,
      totalTasks: 3,
      state: 'Open',
      lastModified: '2025-10-16T16:19:30.779Z',
      number: 140,
      title: 'Pin 1'
    },
    syncLastModified: '2025-10-16T16:19:31.106Z'
  }
]

export const TASKS = [
  {
    createdBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    created: '2025-10-16T16:12:23.171Z',
    lastModifiedBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    lastModified: '2025-10-16T16:12:23.171Z',
    id: 'fb482abc-3891-4630-bf30-5b948f560682',
    issueId: '472ccd32-4cc7-400a-ab78-ab0296cc09f5',
    planId: 'f90b1580-c935-4879-95a3-7e78a73e6f8d',
    type: 'Task',
    active: true,
    commentCount: 0,
    issue: {
      createdBy: {
        id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
        name: 'Danilo Oliveira Lima'
      },
      created: '2025-06-27T12:43:21.557Z',
      lastModifiedBy: {
        id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
        name: 'Danilo Oliveira Lima'
      },
      lastModified: '2025-10-16T16:19:24.666Z',
      id: '472ccd32-4cc7-400a-ab78-ab0296cc09f5',
      projectId: 'db189a81-2b86-42c8-8c27-9575b94dd231',
      number: 117,
      title: 'teste 1',
      description: '',
      category: {
        created: '2024-06-14T18:41:33.860Z',
        lastModified: '2024-06-14T18:41:33.860Z',
        categoryId: '1121e5bb-dd89-419a-ae09-616303978c26',
        name: 'teste 2',
        color: 'DarkBrown',
        active: true,
        orderNumber: 10,
        defaultCategory: false
      },
      priority: 0,
      costs: 0,
      coords: {},
      tags: [],
      fieldValues: {},
      state: 'Open',
      groups: [],
      linkedRecords: [
        {
          id: '173ec907-f8b2-4df3-909a-3c43d9d49386',
          dataSetId: '4b5dc741-27e3-40a0-a2bc-f3dc482cda5e',
          dataSetName: 'table-test',
          idColumnName: 'house number',
          idValue: 'big house',
          titleColumnName: 'name',
          titleValue: 'Danilo',
          record: {
            '5cd34faa-5844-4eca-afb3-22caf1f667b2': 'Danilo',
            '99596b74-4bc4-48e4-bf9d-19d12fb5d2ba': 'big house'
          },
          dataSetVersionId: 'a116034f-1ea0-4e8a-b905-19b480914b9f'
        }
      ],
      permissions: ['Edit', 'ViewHistory'],
      planReference: {
        planId: 'f90b1580-c935-4879-95a3-7e78a73e6f8d',
        planName: 'airoh',
        planFileName: 'airoh.jpeg',
        revisionId: '8940ef16-f8f5-40bc-a31c-2deff07ab416',
        x: 24,
        y: 519,
        active: true,
        objectIds: [],
        cameraSettings: '',
        modelView: ''
      },
      location: {
        id: '472ccd32-4cc7-400a-ab78-ab0296cc09f5',
        x: 24,
        y: 519,
        color: 'DarkBrown',
        indicator: 'Empty',
        indicatorCurrent: 'Open',
        progress: 0,
        totalTasks: 0,
        state: 'Open',
        lastModified: '2025-10-16T16:19:24.666Z',
        number: 117,
        title: 'teste 1'
      },
      syncLastModified: '2025-10-16T16:19:25.040Z'
    },
    number: 1861,
    title: 'create bulk task',
    issueNumber: 117,
    state: 'Open',
    currentState: 'Open',
    stateRecords: [
      {
        state: 'Open',
        setBy: {
          id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
          name: 'Danilo Oliveira Lima'
        },
        created: '2025-10-16T16:12:23.171Z'
      }
    ],
    assignment: {
      type: 'User',
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima',
      companyId: 'd8859c49-6d1c-4ddd-b74e-38350f3380a6',
      companyName: 'docu tools SAML',
      state: 'Active',
      phone: '+5511941191781',
      email: 'd.oliveira@docu-tools.com',
      countryCode: 'AT'
    },
    dependencies: [],
    alert: {},
    done: false,
    rejected: false,
    category: {
      created: '2024-06-14T18:41:33.860Z',
      lastModified: '2024-06-14T18:41:33.860Z',
      categoryId: '1121e5bb-dd89-419a-ae09-616303978c26',
      name: 'teste 2',
      color: 'DarkBrown',
      active: true,
      orderNumber: 10,
      defaultCategory: false
    },
    callsForActions: [],
    actions: ['Close', 'Deactivate'],
    hierarchicalActions: {
      primary: null,
      secondary: 'Close',
      tertiaries: ['Close', 'Deactivate']
    },
    attachments: [],
    permissions: ['Edit', 'ViewHistory']
  },
  {
    createdBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    created: '2025-10-16T16:14:17.081Z',
    lastModifiedBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    lastModified: '2025-10-16T16:14:17.081Z',
    id: '2c9043ca-7914-46e6-bf69-36cd42c8b33a',
    issueId: '472ccd32-4cc7-400a-ab78-ab0296cc09f5',
    planId: 'f90b1580-c935-4879-95a3-7e78a73e6f8d',
    type: 'Task',
    active: true,
    commentCount: 0,
    issue: {
      createdBy: {
        id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
        name: 'Danilo Oliveira Lima'
      },
      created: '2025-06-27T12:43:21.557Z',
      lastModifiedBy: {
        id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
        name: 'Danilo Oliveira Lima'
      },
      lastModified: '2025-10-16T16:19:24.666Z',
      id: '472ccd32-4cc7-400a-ab78-ab0296cc09f5',
      projectId: 'db189a81-2b86-42c8-8c27-9575b94dd231',
      number: 117,
      title: 'teste 1',
      description: '',
      category: {
        created: '2024-06-14T18:41:33.860Z',
        lastModified: '2024-06-14T18:41:33.860Z',
        categoryId: '1121e5bb-dd89-419a-ae09-616303978c26',
        name: 'teste 2',
        color: 'DarkBrown',
        active: true,
        orderNumber: 10,
        defaultCategory: false
      },
      priority: 0,
      costs: 0,
      coords: {},
      tags: [],
      fieldValues: {},
      state: 'Open',
      groups: [],
      linkedRecords: [
        {
          id: '173ec907-f8b2-4df3-909a-3c43d9d49386',
          dataSetId: '4b5dc741-27e3-40a0-a2bc-f3dc482cda5e',
          dataSetName: 'table-test',
          idColumnName: 'house number',
          idValue: 'big house',
          titleColumnName: 'name',
          titleValue: 'Danilo',
          record: {
            '5cd34faa-5844-4eca-afb3-22caf1f667b2': 'Danilo',
            '99596b74-4bc4-48e4-bf9d-19d12fb5d2ba': 'big house'
          },
          dataSetVersionId: 'a116034f-1ea0-4e8a-b905-19b480914b9f'
        }
      ],
      permissions: ['Edit', 'ViewHistory'],
      planReference: {
        planId: 'f90b1580-c935-4879-95a3-7e78a73e6f8d',
        planName: 'airoh',
        planFileName: 'airoh.jpeg',
        revisionId: '8940ef16-f8f5-40bc-a31c-2deff07ab416',
        x: 24,
        y: 519,
        active: true,
        objectIds: [],
        cameraSettings: '',
        modelView: ''
      },
      location: {
        id: '472ccd32-4cc7-400a-ab78-ab0296cc09f5',
        x: 24,
        y: 519,
        color: 'DarkBrown',
        indicator: 'Empty',
        indicatorCurrent: 'Open',
        progress: 0,
        totalTasks: 0,
        state: 'Open',
        lastModified: '2025-10-16T16:19:24.666Z',
        number: 117,
        title: 'teste 1'
      },
      syncLastModified: '2025-10-16T16:19:25.040Z'
    },
    number: 2001,
    title: 'create bulk tasks 2',
    issueNumber: 117,
    state: 'Open',
    currentState: 'Open',
    stateRecords: [
      {
        state: 'Open',
        setBy: {
          id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
          name: 'Danilo Oliveira Lima'
        },
        created: '2025-10-16T16:14:17.081Z'
      }
    ],
    assignment: {
      type: 'User',
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima',
      companyId: 'd8859c49-6d1c-4ddd-b74e-38350f3380a6',
      companyName: 'docu tools SAML',
      state: 'Active',
      phone: '+5511941191781',
      email: 'd.oliveira@docu-tools.com',
      countryCode: 'AT'
    },
    dependencies: [],
    alert: {},
    done: false,
    rejected: false,
    category: {
      created: '2024-06-14T18:41:33.860Z',
      lastModified: '2024-06-14T18:41:33.860Z',
      categoryId: '1121e5bb-dd89-419a-ae09-616303978c26',
      name: 'teste 2',
      color: 'DarkBrown',
      active: true,
      orderNumber: 10,
      defaultCategory: false
    },
    callsForActions: [],
    actions: ['Close', 'Deactivate'],
    hierarchicalActions: {
      primary: null,
      secondary: 'Close',
      tertiaries: ['Close', 'Deactivate']
    },
    attachments: [],
    permissions: ['Edit', 'ViewHistory']
  },
  {
    createdBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    created: '2025-10-16T16:19:24.666Z',
    lastModifiedBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    lastModified: '2025-10-16T16:19:24.666Z',
    id: 'b180c7e2-a09c-4459-abb2-e01389be500e',
    issueId: '472ccd32-4cc7-400a-ab78-ab0296cc09f5',
    planId: 'f90b1580-c935-4879-95a3-7e78a73e6f8d',
    type: 'Task',
    active: true,
    commentCount: 0,
    issue: {
      createdBy: {
        id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
        name: 'Danilo Oliveira Lima'
      },
      created: '2025-06-27T12:43:21.557Z',
      lastModifiedBy: {
        id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
        name: 'Danilo Oliveira Lima'
      },
      lastModified: '2025-10-16T16:19:24.666Z',
      id: '472ccd32-4cc7-400a-ab78-ab0296cc09f5',
      projectId: 'db189a81-2b86-42c8-8c27-9575b94dd231',
      number: 117,
      title: 'teste 1',
      description: '',
      category: {
        created: '2024-06-14T18:41:33.860Z',
        lastModified: '2024-06-14T18:41:33.860Z',
        categoryId: '1121e5bb-dd89-419a-ae09-616303978c26',
        name: 'teste 2',
        color: 'DarkBrown',
        active: true,
        orderNumber: 10,
        defaultCategory: false
      },
      priority: 0,
      costs: 0,
      coords: {},
      tags: [],
      fieldValues: {},
      state: 'Open',
      groups: [],
      linkedRecords: [
        {
          id: '173ec907-f8b2-4df3-909a-3c43d9d49386',
          dataSetId: '4b5dc741-27e3-40a0-a2bc-f3dc482cda5e',
          dataSetName: 'table-test',
          idColumnName: 'house number',
          idValue: 'big house',
          titleColumnName: 'name',
          titleValue: 'Danilo',
          record: {
            '5cd34faa-5844-4eca-afb3-22caf1f667b2': 'Danilo',
            '99596b74-4bc4-48e4-bf9d-19d12fb5d2ba': 'big house'
          },
          dataSetVersionId: 'a116034f-1ea0-4e8a-b905-19b480914b9f'
        }
      ],
      permissions: ['Edit', 'ViewHistory'],
      planReference: {
        planId: 'f90b1580-c935-4879-95a3-7e78a73e6f8d',
        planName: 'airoh',
        planFileName: 'airoh.jpeg',
        revisionId: '8940ef16-f8f5-40bc-a31c-2deff07ab416',
        x: 24,
        y: 519,
        active: true,
        objectIds: [],
        cameraSettings: '',
        modelView: ''
      },
      location: {
        id: '472ccd32-4cc7-400a-ab78-ab0296cc09f5',
        x: 24,
        y: 519,
        color: 'DarkBrown',
        indicator: 'Empty',
        indicatorCurrent: 'Open',
        progress: 0,
        totalTasks: 0,
        state: 'Open',
        lastModified: '2025-10-16T16:19:24.666Z',
        number: 117,
        title: 'teste 1'
      },
      syncLastModified: '2025-10-16T16:19:25.040Z'
    },
    number: 2142,
    title: 'task bulk 3',
    issueNumber: 117,
    state: 'Open',
    currentState: 'Open',
    stateRecords: [
      {
        state: 'Open',
        setBy: {
          id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
          name: 'Danilo Oliveira Lima'
        },
        created: '2025-10-16T16:19:24.666Z'
      }
    ],
    assignment: {
      type: 'User',
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima',
      companyId: 'd8859c49-6d1c-4ddd-b74e-38350f3380a6',
      companyName: 'docu tools SAML',
      state: 'Active',
      phone: '+5511941191781',
      email: 'd.oliveira@docu-tools.com',
      countryCode: 'AT'
    },
    dependencies: [],
    alert: {},
    done: false,
    rejected: false,
    category: {
      created: '2024-06-14T18:41:33.860Z',
      lastModified: '2024-06-14T18:41:33.860Z',
      categoryId: '1121e5bb-dd89-419a-ae09-616303978c26',
      name: 'teste 2',
      color: 'DarkBrown',
      active: true,
      orderNumber: 10,
      defaultCategory: false
    },
    callsForActions: [],
    actions: ['Close', 'Deactivate'],
    hierarchicalActions: {
      primary: null,
      secondary: 'Close',
      tertiaries: ['Close', 'Deactivate']
    },
    attachments: [],
    permissions: ['Edit', 'ViewHistory']
  },
  {
    createdBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    created: '2025-10-16T16:12:03.250Z',
    lastModifiedBy: {
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima'
    },
    lastModified: '2025-10-16T16:12:03.250Z',
    id: 'dd0c76fe-cf63-4a30-8c77-37105204166c',
    issueId: 'bcba98d3-ac53-4c6b-82e9-272920fcfc6d',
    planId: 'e811f5a4-d6ab-42c4-b56b-5d8e2c51d502',
    type: 'Task',
    active: true,
    commentCount: 0,
    issue: {
      createdBy: {
        id: 'f579379b-1d64-405f-a0cd-9cd90ebe2763',
        name: 'Jose Pinto'
      },
      created: '2024-07-23T21:43:59.954Z',
      lastModifiedBy: {
        id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
        name: 'Danilo Oliveira Lima'
      },
      lastModified: '2025-10-16T16:19:04.456Z',
      id: 'bcba98d3-ac53-4c6b-82e9-272920fcfc6d',
      projectId: 'db189a81-2b86-42c8-8c27-9575b94dd231',
      number: 38,
      title: 'teste 1',
      description: '',
      category: {
        created: '2023-12-01T14:17:13.783Z',
        lastModified: '2023-12-01T14:17:13.783Z',
        categoryId: '1fe39c15-b30f-4d9a-884f-2c70552e83ef',
        name: 'Defecta',
        color: 'Red',
        active: true,
        orderNumber: 2,
        defaultCategory: false
      },
      priority: 0,
      costs: 0,
      coords: {},
      tags: [],
      fieldValues: {},
      state: 'Open',
      groups: [],
      linkedRecords: [
        {
          id: '173ec907-f8b2-4df3-909a-3c43d9d49386',
          dataSetId: '4b5dc741-27e3-40a0-a2bc-f3dc482cda5e',
          dataSetName: 'table-test',
          idColumnName: 'house number',
          idValue: 'big house',
          titleColumnName: 'name',
          titleValue: 'Danilo',
          record: {
            '5cd34faa-5844-4eca-afb3-22caf1f667b2': 'Danilo',
            '99596b74-4bc4-48e4-bf9d-19d12fb5d2ba': 'big house'
          },
          dataSetVersionId: 'a116034f-1ea0-4e8a-b905-19b480914b9f'
        }
      ],
      permissions: ['Edit', 'ViewHistory'],
      planReference: {
        planId: 'e811f5a4-d6ab-42c4-b56b-5d8e2c51d502',
        planName: 'Airoh with Pinssss',
        planFileName: 'airoh1 copy.jpeg',
        revisionId: '4509c991-0ef8-4a83-b9e9-8234bd4dee9c',
        x: 766,
        y: 572,
        active: true,
        objectIds: [],
        cameraSettings: '',
        modelView: ''
      },
      location: {
        id: 'bcba98d3-ac53-4c6b-82e9-272920fcfc6d',
        x: 766,
        y: 572,
        color: 'Red',
        indicator: 'Empty',
        indicatorCurrent: 'Open',
        progress: 0,
        totalTasks: 0,
        state: 'Open',
        lastModified: '2025-10-16T16:19:04.456Z',
        number: 38,
        title: 'teste 1'
      },
      syncLastModified: '2025-10-16T16:19:04.700Z'
    },
    number: 1783,
    title: 'create bulk task',
    issueNumber: 38,
    state: 'Open',
    currentState: 'Open',
    stateRecords: [
      {
        state: 'Open',
        setBy: {
          id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
          name: 'Danilo Oliveira Lima'
        },
        created: '2025-10-16T16:12:03.250Z'
      }
    ],
    assignment: {
      type: 'User',
      id: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      name: 'Danilo Oliveira Lima',
      companyId: 'd8859c49-6d1c-4ddd-b74e-38350f3380a6',
      companyName: 'docu tools SAML',
      state: 'Active',
      phone: '+5511941191781',
      email: 'd.oliveira@docu-tools.com',
      countryCode: 'AT'
    },
    dependencies: [],
    alert: {},
    done: false,
    rejected: false,
    category: {
      created: '2023-12-01T14:17:13.783Z',
      lastModified: '2023-12-01T14:17:13.783Z',
      categoryId: '1fe39c15-b30f-4d9a-884f-2c70552e83ef',
      name: 'Defecta',
      color: 'Red',
      active: true,
      orderNumber: 2,
      defaultCategory: false
    },
    callsForActions: [],
    actions: ['Close', 'Deactivate'],
    hierarchicalActions: {
      primary: null,
      secondary: 'Close',
      tertiaries: ['Close', 'Deactivate']
    },
    attachments: [],
    permissions: ['Edit', 'ViewHistory']
  }
]

export const PLANS = [
  {
    id: 'f90b1580-c935-4879-95a3-7e78a73e6f8d',
    projectId: 'db189a81-2b86-42c8-8c27-9575b94dd231',
    name: 'airoh',
    currentRevisionId: '8940ef16-f8f5-40bc-a31c-2deff07ab416',
    currentRevision: {
      id: '8940ef16-f8f5-40bc-a31c-2deff07ab416',
      level: [
        {
          id: '5e62eb29-d7c7-40fd-9b7e-b28652a53d05',
          width: 1024,
          height: 1024,
          tilesX: 4,
          tilesY: 4,
          storageId:
            'https://s3.eu-central-1.amazonaws.com/docutools-prod-plans/db189a81-2b86-42c8-8c27-9575b94dd231/f90b1580-c935-4879-95a3-7e78a73e6f8d/8940ef16-f8f5-40bc-a31c-2deff07ab416/3/',
          downloadUrl:
            'https://api.docu-tools.com/api/v2/plans/revisions/8940ef16-f8f5-40bc-a31c-2deff07ab416/3/',
          squarified: false
        },
        {
          id: 'b59fc173-5c5e-45e0-9dce-73395e414e8f',
          width: 512,
          height: 512,
          tilesX: 2,
          tilesY: 2,
          storageId:
            'https://s3.eu-central-1.amazonaws.com/docutools-prod-plans/db189a81-2b86-42c8-8c27-9575b94dd231/f90b1580-c935-4879-95a3-7e78a73e6f8d/8940ef16-f8f5-40bc-a31c-2deff07ab416/2/',
          downloadUrl:
            'https://api.docu-tools.com/api/v2/plans/revisions/8940ef16-f8f5-40bc-a31c-2deff07ab416/2/',
          squarified: false
        },
        {
          id: 'fe43db89-0460-45e3-9adb-586df6eaa524',
          width: 256,
          height: 256,
          tilesX: 1,
          tilesY: 1,
          storageId:
            'https://s3.eu-central-1.amazonaws.com/docutools-prod-plans/db189a81-2b86-42c8-8c27-9575b94dd231/f90b1580-c935-4879-95a3-7e78a73e6f8d/8940ef16-f8f5-40bc-a31c-2deff07ab416/1/',
          downloadUrl:
            'https://api.docu-tools.com/api/v2/plans/revisions/8940ef16-f8f5-40bc-a31c-2deff07ab416/1/',
          squarified: false
        }
      ],
      s3FolderId: '8940ef16-f8f5-40bc-a31c-2deff07ab416',
      version: '1',
      metadata: {
        planType: 'File',
        imageWidth: 800,
        imageHeight: 800,
        fileName: 'airoh.jpeg',
        contentType: 'image/jpeg',
        checksum: '57c1885638c6e7365967124d293171c9',
        archiveSize: 177152,
        thumbnailChecksum: '255dc1c495c40472db482d3e31429791',
        rotation: 0,
        page: -1,
        webpSupported: false,
        tileExtension: 'jpg',
        indexedArchive: false
      },
      username: 'j.pinto@docu-tools.com',
      archiveDownloadUrl:
        'https://docutools-prod-plans.s3.eu-central-1.amazonaws.com/db189a81-2b86-42c8-8c27-9575b94dd231/f90b1580-c935-4879-95a3-7e78a73e6f8d/8940ef16-f8f5-40bc-a31c-2deff07ab416/revision.tar?X-Amz-Security-Token=IQoJb3JpZ2luX2VjEKn%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDGV1LWNlbnRyYWwtMSJGMEQCIHcY2a8hkZJnoggjofL3B6fjgA51xTE%2F53QJrahk1IOLAiAHICZQc9hnm%2Fe5f23x1TyxhAtrmQ5ucoxk%2BdB5AjhYriqYAghiEAQaDDY3OTIzMDQyMDI2NyIMgeJ95CDvXO%2BshkorKvUBwavjc2UoKNu1RXzsH0ZoySwsY6EUVgPDIyXCcxlbR3ZW8RhClUVnh7IiyMF5xujLBoaJ9AnQG8rgCv6jyhlDYwwMVZDJwcgoMoNuvdRXMuDzOpI9DkgPxX8Lg8BMLF9IwL5BIfh%2Fp0cA%2BnmOR3skEGHPwjBwj%2Bd0wH1nhl2VD4a5QRPr1sNo3A4qGM%2FvGoYuz5iLxCC8Odh5978aAdz4DYfSnQKn6thRQOymtL3qK5VORDwAyyD1Sbm%2FavPbWnJPZjBZ6H6tKbuCRGQVkcVmwhb6VQLxQg625H1qzRldu5niAGKhwdgCUYgldn8N6dCDih%2FjCEgw69TuxwY6ngHRZgfuM%2FRER%2B60IvJptDW9jywyW3AaMRNphy0ir1QCFimF9uogcVbkVJxg1clMWI8BTN0f1PcRzyV%2BwerSZbLj0NMhonthwq2zsr7FswaABn7cZd5qA1vfG%2FnuAHegNnPK6UXYFrNDjnYziZoJs%2FdKdgx0oNOAXNbdJrvugLlthyWN5OmWZ8RYsRnJMH3kHyO%2Be49gRg8lDDxCvtUcVQ%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20251024T213616Z&X-Amz-SignedHeaders=host&X-Amz-Credential=ASIAZ4JKJWUV3HUNONFR%2F20251024%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Expires=36000&X-Amz-Signature=adf42408f3235fbe14e583770fde88073663d70a7cefe5f59466f63977e4951b',
      originalDownloadUrl:
        'https://docutools-prod-plans.s3.eu-central-1.amazonaws.com/db189a81-2b86-42c8-8c27-9575b94dd231/f90b1580-c935-4879-95a3-7e78a73e6f8d/8940ef16-f8f5-40bc-a31c-2deff07ab416/airoh.jpeg?X-Amz-Security-Token=IQoJb3JpZ2luX2VjEKn%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDGV1LWNlbnRyYWwtMSJGMEQCIHcY2a8hkZJnoggjofL3B6fjgA51xTE%2F53QJrahk1IOLAiAHICZQc9hnm%2Fe5f23x1TyxhAtrmQ5ucoxk%2BdB5AjhYriqYAghiEAQaDDY3OTIzMDQyMDI2NyIMgeJ95CDvXO%2BshkorKvUBwavjc2UoKNu1RXzsH0ZoySwsY6EUVgPDIyXCcxlbR3ZW8RhClUVnh7IiyMF5xujLBoaJ9AnQG8rgCv6jyhlDYwwMVZDJwcgoMoNuvdRXMuDzOpI9DkgPxX8Lg8BMLF9IwL5BIfh%2Fp0cA%2BnmOR3skEGHPwjBwj%2Bd0wH1nhl2VD4a5QRPr1sNo3A4qGM%2FvGoYuz5iLxCC8Odh5978aAdz4DYfSnQKn6thRQOymtL3qK5VORDwAyyD1Sbm%2FavPbWnJPZjBZ6H6tKbuCRGQVkcVmwhb6VQLxQg625H1qzRldu5niAGKhwdgCUYgldn8N6dCDih%2FjCEgw69TuxwY6ngHRZgfuM%2FRER%2B60IvJptDW9jywyW3AaMRNphy0ir1QCFimF9uogcVbkVJxg1clMWI8BTN0f1PcRzyV%2BwerSZbLj0NMhonthwq2zsr7FswaABn7cZd5qA1vfG%2FnuAHegNnPK6UXYFrNDjnYziZoJs%2FdKdgx0oNOAXNbdJrvugLlthyWN5OmWZ8RYsRnJMH3kHyO%2Be49gRg8lDDxCvtUcVQ%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20251024T213616Z&X-Amz-SignedHeaders=host&X-Amz-Credential=ASIAZ4JKJWUV3HUNONFR%2F20251024%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Expires=36000&X-Amz-Signature=008f23f72cb704ae8de3bc9e4d4a7051b7f76215f86bafef821777ccb95e08d7',
      revisionLocationDifference: {
        moveX: 0,
        moveY: 0,
        factor: 1
      },
      allowSetActive: true,
      overwritePlanname: false,
      coords: [],
      createdBy: 'f579379b-1d64-405f-a0cd-9cd90ebe2763',
      created: '2024-01-09T20:16:06.527Z',
      lastModifiedBy: '97115f74-f2fc-4ba7-88c7-80ac008353c7',
      lastModified: '2024-04-23T20:22:26.853Z'
    },
    revisions: [],
    active: true,
    s3FolderId: 'f90b1580-c935-4879-95a3-7e78a73e6f8d',
    metadata: {
      planType: 'File',
      imageWidth: 800,
      imageHeight: 800,
      fileName: 'airoh.jpeg',
      contentType: 'image/jpeg',
      checksum: '57c1885638c6e7365967124d293171c9',
      archiveSize: 177152,
      thumbnailChecksum: '255dc1c495c40472db482d3e31429791',
      rotation: 0,
      page: -1,
      webpSupported: false,
      tileExtension: 'jpg',
      indexedArchive: false
    },
    planType: 'File',
    parentId: 'a26cbc48-658b-4264-8fd1-8f6119243b7b',
    parentName: 'Test',
    permissions: [],
    openTaskCount: 0,
    lastActivity: '2025-10-24T15:23:17.849Z',
    lock: false
  },
  {
    id: 'e811f5a4-d6ab-42c4-b56b-5d8e2c51d502',
    projectId: 'db189a81-2b86-42c8-8c27-9575b94dd231',
    name: 'Airoh with Pinssss',
    currentRevisionId: 'b270f6c8-eaf9-41d2-8966-6d7effef1b85',
    currentRevision: {
      id: 'b270f6c8-eaf9-41d2-8966-6d7effef1b85',
      level: [
        {
          id: '3cd53f59-afa2-49bf-956d-e3edf3a7756e',
          width: 1024,
          height: 1024,
          tilesX: 4,
          tilesY: 4,
          storageId:
            'https://s3.eu-central-1.amazonaws.com/docutools-prod-plans/db189a81-2b86-42c8-8c27-9575b94dd231/e811f5a4-d6ab-42c4-b56b-5d8e2c51d502/b270f6c8-eaf9-41d2-8966-6d7effef1b85/3/',
          downloadUrl:
            'https://api.docu-tools.com/api/v2/plans/revisions/b270f6c8-eaf9-41d2-8966-6d7effef1b85/3/',
          squarified: false
        },
        {
          id: 'd190b984-3fd3-463d-990b-dc788c65968e',
          width: 512,
          height: 512,
          tilesX: 2,
          tilesY: 2,
          storageId:
            'https://s3.eu-central-1.amazonaws.com/docutools-prod-plans/db189a81-2b86-42c8-8c27-9575b94dd231/e811f5a4-d6ab-42c4-b56b-5d8e2c51d502/b270f6c8-eaf9-41d2-8966-6d7effef1b85/2/',
          downloadUrl:
            'https://api.docu-tools.com/api/v2/plans/revisions/b270f6c8-eaf9-41d2-8966-6d7effef1b85/2/',
          squarified: false
        },
        {
          id: '6e48b8b6-f111-41e6-86ce-4e2f8714697f',
          width: 256,
          height: 256,
          tilesX: 1,
          tilesY: 1,
          storageId:
            'https://s3.eu-central-1.amazonaws.com/docutools-prod-plans/db189a81-2b86-42c8-8c27-9575b94dd231/e811f5a4-d6ab-42c4-b56b-5d8e2c51d502/b270f6c8-eaf9-41d2-8966-6d7effef1b85/1/',
          downloadUrl:
            'https://api.docu-tools.com/api/v2/plans/revisions/b270f6c8-eaf9-41d2-8966-6d7effef1b85/1/',
          squarified: false
        }
      ],
      s3FolderId: 'b270f6c8-eaf9-41d2-8966-6d7effef1b85',
      version: '2',
      metadata: {
        planType: 'File',
        imageWidth: 800,
        imageHeight: 800,
        fileName: 'airoh1 copy.jpeg',
        contentType: 'image/jpeg',
        checksum: 'cb52e4cdd5910c0bbe94d5a5950b77cf',
        archiveSize: 122880,
        thumbnailChecksum: 'ffb303243b04da0e129e8498d37ad5a2',
        rotation: 0,
        page: -1,
        webpSupported: true,
        tileExtension: 'webp',
        indexedArchive: false
      },
      username: 'j.pinto@docu-tools.com',
      archiveDownloadUrl:
        'https://docutools-prod-plans.s3.eu-central-1.amazonaws.com/db189a81-2b86-42c8-8c27-9575b94dd231/e811f5a4-d6ab-42c4-b56b-5d8e2c51d502/b270f6c8-eaf9-41d2-8966-6d7effef1b85/revision.tar?X-Amz-Security-Token=IQoJb3JpZ2luX2VjEKn%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDGV1LWNlbnRyYWwtMSJGMEQCIHcY2a8hkZJnoggjofL3B6fjgA51xTE%2F53QJrahk1IOLAiAHICZQc9hnm%2Fe5f23x1TyxhAtrmQ5ucoxk%2BdB5AjhYriqYAghiEAQaDDY3OTIzMDQyMDI2NyIMgeJ95CDvXO%2BshkorKvUBwavjc2UoKNu1RXzsH0ZoySwsY6EUVgPDIyXCcxlbR3ZW8RhClUVnh7IiyMF5xujLBoaJ9AnQG8rgCv6jyhlDYwwMVZDJwcgoMoNuvdRXMuDzOpI9DkgPxX8Lg8BMLF9IwL5BIfh%2Fp0cA%2BnmOR3skEGHPwjBwj%2Bd0wH1nhl2VD4a5QRPr1sNo3A4qGM%2FvGoYuz5iLxCC8Odh5978aAdz4DYfSnQKn6thRQOymtL3qK5VORDwAyyD1Sbm%2FavPbWnJPZjBZ6H6tKbuCRGQVkcVmwhb6VQLxQg625H1qzRldu5niAGKhwdgCUYgldn8N6dCDih%2FjCEgw69TuxwY6ngHRZgfuM%2FRER%2B60IvJptDW9jywyW3AaMRNphy0ir1QCFimF9uogcVbkVJxg1clMWI8BTN0f1PcRzyV%2BwerSZbLj0NMhonthwq2zsr7FswaABn7cZd5qA1vfG%2FnuAHegNnPK6UXYFrNDjnYziZoJs%2FdKdgx0oNOAXNbdJrvugLlthyWN5OmWZ8RYsRnJMH3kHyO%2Be49gRg8lDDxCvtUcVQ%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20251024T213616Z&X-Amz-SignedHeaders=host&X-Amz-Credential=ASIAZ4JKJWUV3HUNONFR%2F20251024%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Expires=36000&X-Amz-Signature=c01f061132110b078c99e1db9b731b929b06d87a87597e3f7b16bf3bf4897125',
      originalDownloadUrl:
        'https://docutools-prod-plans.s3.eu-central-1.amazonaws.com/db189a81-2b86-42c8-8c27-9575b94dd231/e811f5a4-d6ab-42c4-b56b-5d8e2c51d502/b270f6c8-eaf9-41d2-8966-6d7effef1b85/airoh1%20copy.jpeg?X-Amz-Security-Token=IQoJb3JpZ2luX2VjEKn%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDGV1LWNlbnRyYWwtMSJGMEQCIHcY2a8hkZJnoggjofL3B6fjgA51xTE%2F53QJrahk1IOLAiAHICZQc9hnm%2Fe5f23x1TyxhAtrmQ5ucoxk%2BdB5AjhYriqYAghiEAQaDDY3OTIzMDQyMDI2NyIMgeJ95CDvXO%2BshkorKvUBwavjc2UoKNu1RXzsH0ZoySwsY6EUVgPDIyXCcxlbR3ZW8RhClUVnh7IiyMF5xujLBoaJ9AnQG8rgCv6jyhlDYwwMVZDJwcgoMoNuvdRXMuDzOpI9DkgPxX8Lg8BMLF9IwL5BIfh%2Fp0cA%2BnmOR3skEGHPwjBwj%2Bd0wH1nhl2VD4a5QRPr1sNo3A4qGM%2FvGoYuz5iLxCC8Odh5978aAdz4DYfSnQKn6thRQOymtL3qK5VORDwAyyD1Sbm%2FavPbWnJPZjBZ6H6tKbuCRGQVkcVmwhb6VQLxQg625H1qzRldu5niAGKhwdgCUYgldn8N6dCDih%2FjCEgw69TuxwY6ngHRZgfuM%2FRER%2B60IvJptDW9jywyW3AaMRNphy0ir1QCFimF9uogcVbkVJxg1clMWI8BTN0f1PcRzyV%2BwerSZbLj0NMhonthwq2zsr7FswaABn7cZd5qA1vfG%2FnuAHegNnPK6UXYFrNDjnYziZoJs%2FdKdgx0oNOAXNbdJrvugLlthyWN5OmWZ8RYsRnJMH3kHyO%2Be49gRg8lDDxCvtUcVQ%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20251024T213616Z&X-Amz-SignedHeaders=host&X-Amz-Credential=ASIAZ4JKJWUV3HUNONFR%2F20251024%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Expires=36000&X-Amz-Signature=a201586a8b8ecd705329528e7feae6c49f2ae6f6be16038d57c5c25447a4ca23',
      revisionLocationDifference: {
        moveX: 0,
        moveY: 0,
        factor: 1
      },
      allowSetActive: true,
      overwritePlanname: false,
      coords: [],
      createdBy: 'f579379b-1d64-405f-a0cd-9cd90ebe2763',
      created: '2024-07-25T15:30:40.644Z',
      lastModifiedBy: 'c534d36c-21e2-478d-bd37-6104af8130c0',
      lastModified: '2024-08-06T12:52:23.126Z'
    },
    revisions: [],
    active: true,
    s3FolderId: 'e811f5a4-d6ab-42c4-b56b-5d8e2c51d502',
    metadata: {
      planType: 'File',
      imageWidth: 800,
      imageHeight: 800,
      fileName: 'airoh1 copy.jpeg',
      contentType: 'image/jpeg',
      checksum: 'cb52e4cdd5910c0bbe94d5a5950b77cf',
      archiveSize: 122880,
      thumbnailChecksum: 'ffb303243b04da0e129e8498d37ad5a2',
      rotation: 0,
      page: -1,
      webpSupported: true,
      tileExtension: 'webp',
      indexedArchive: false
    },
    planType: 'File',
    parentId: 'a26cbc48-658b-4264-8fd1-8f6119243b7b',
    parentName: 'Test',
    permissions: [],
    openTaskCount: 0,
    lastActivity: '2025-10-20T13:05:46.618Z',
    lock: false
  },
  {
    id: 'd1e2df05-6de8-45c2-a096-2a7c01306168',
    projectId: 'db189a81-2b86-42c8-8c27-9575b94dd231',
    name: 'airoh1132123',
    currentRevisionId: '0045ef69-22dd-45ab-abf4-34ca868c024e',
    currentRevision: {
      id: '0045ef69-22dd-45ab-abf4-34ca868c024e',
      level: [
        {
          id: '949e4712-ed14-4569-8835-5183fd7c5c4c',
          width: 1024,
          height: 1024,
          tilesX: 4,
          tilesY: 4,
          storageId:
            'https://s3.eu-central-1.amazonaws.com/docutools-prod-plans/db189a81-2b86-42c8-8c27-9575b94dd231/d1e2df05-6de8-45c2-a096-2a7c01306168/0045ef69-22dd-45ab-abf4-34ca868c024e/3/',
          downloadUrl:
            'https://api.docu-tools.com/api/v2/plans/revisions/0045ef69-22dd-45ab-abf4-34ca868c024e/3/',
          squarified: false
        },
        {
          id: 'cb697bf5-12d1-4b5a-9ff8-798a2d6b9f02',
          width: 512,
          height: 512,
          tilesX: 2,
          tilesY: 2,
          storageId:
            'https://s3.eu-central-1.amazonaws.com/docutools-prod-plans/db189a81-2b86-42c8-8c27-9575b94dd231/d1e2df05-6de8-45c2-a096-2a7c01306168/0045ef69-22dd-45ab-abf4-34ca868c024e/2/',
          downloadUrl:
            'https://api.docu-tools.com/api/v2/plans/revisions/0045ef69-22dd-45ab-abf4-34ca868c024e/2/',
          squarified: false
        },
        {
          id: '67c39854-f364-4f1a-bffb-9010fd1435d1',
          width: 256,
          height: 256,
          tilesX: 1,
          tilesY: 1,
          storageId:
            'https://s3.eu-central-1.amazonaws.com/docutools-prod-plans/db189a81-2b86-42c8-8c27-9575b94dd231/d1e2df05-6de8-45c2-a096-2a7c01306168/0045ef69-22dd-45ab-abf4-34ca868c024e/1/',
          downloadUrl:
            'https://api.docu-tools.com/api/v2/plans/revisions/0045ef69-22dd-45ab-abf4-34ca868c024e/1/',
          squarified: false
        }
      ],
      s3FolderId: '0045ef69-22dd-45ab-abf4-34ca868c024e',
      version: '1',
      metadata: {
        planType: 'File',
        imageWidth: 800,
        imageHeight: 800,
        fileName: 'airoh1 copy.jpeg',
        contentType: 'image/jpeg',
        checksum: 'f5f91b85efa37881078a332e5cb32195',
        archiveSize: 122880,
        rotation: 0,
        page: -1,
        webpSupported: true,
        tileExtension: 'webp',
        indexedArchive: true
      },
      username: 'j.pinto@docu-tools.com',
      archiveDownloadUrl:
        'https://docutools-prod-plans.s3.eu-central-1.amazonaws.com/db189a81-2b86-42c8-8c27-9575b94dd231/d1e2df05-6de8-45c2-a096-2a7c01306168/0045ef69-22dd-45ab-abf4-34ca868c024e/revision.tar?X-Amz-Security-Token=IQoJb3JpZ2luX2VjEKn%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDGV1LWNlbnRyYWwtMSJGMEQCIHcY2a8hkZJnoggjofL3B6fjgA51xTE%2F53QJrahk1IOLAiAHICZQc9hnm%2Fe5f23x1TyxhAtrmQ5ucoxk%2BdB5AjhYriqYAghiEAQaDDY3OTIzMDQyMDI2NyIMgeJ95CDvXO%2BshkorKvUBwavjc2UoKNu1RXzsH0ZoySwsY6EUVgPDIyXCcxlbR3ZW8RhClUVnh7IiyMF5xujLBoaJ9AnQG8rgCv6jyhlDYwwMVZDJwcgoMoNuvdRXMuDzOpI9DkgPxX8Lg8BMLF9IwL5BIfh%2Fp0cA%2BnmOR3skEGHPwjBwj%2Bd0wH1nhl2VD4a5QRPr1sNo3A4qGM%2FvGoYuz5iLxCC8Odh5978aAdz4DYfSnQKn6thRQOymtL3qK5VORDwAyyD1Sbm%2FavPbWnJPZjBZ6H6tKbuCRGQVkcVmwhb6VQLxQg625H1qzRldu5niAGKhwdgCUYgldn8N6dCDih%2FjCEgw69TuxwY6ngHRZgfuM%2FRER%2B60IvJptDW9jywyW3AaMRNphy0ir1QCFimF9uogcVbkVJxg1clMWI8BTN0f1PcRzyV%2BwerSZbLj0NMhonthwq2zsr7FswaABn7cZd5qA1vfG%2FnuAHegNnPK6UXYFrNDjnYziZoJs%2FdKdgx0oNOAXNbdJrvugLlthyWN5OmWZ8RYsRnJMH3kHyO%2Be49gRg8lDDxCvtUcVQ%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20251024T213616Z&X-Amz-SignedHeaders=host&X-Amz-Credential=ASIAZ4JKJWUV3HUNONFR%2F20251024%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Expires=36000&X-Amz-Signature=c4f6765a97ed6d42fc4a797c28dccbd5d0706edb28e282a2cf33ccb51bbc2b07',
      originalDownloadUrl:
        'https://docutools-prod-plans.s3.eu-central-1.amazonaws.com/db189a81-2b86-42c8-8c27-9575b94dd231/d1e2df05-6de8-45c2-a096-2a7c01306168/0045ef69-22dd-45ab-abf4-34ca868c024e/airoh1%20copy.jpeg?X-Amz-Security-Token=IQoJb3JpZ2luX2VjEKn%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDGV1LWNlbnRyYWwtMSJGMEQCIHcY2a8hkZJnoggjofL3B6fjgA51xTE%2F53QJrahk1IOLAiAHICZQc9hnm%2Fe5f23x1TyxhAtrmQ5ucoxk%2BdB5AjhYriqYAghiEAQaDDY3OTIzMDQyMDI2NyIMgeJ95CDvXO%2BshkorKvUBwavjc2UoKNu1RXzsH0ZoySwsY6EUVgPDIyXCcxlbR3ZW8RhClUVnh7IiyMF5xujLBoaJ9AnQG8rgCv6jyhlDYwwMVZDJwcgoMoNuvdRXMuDzOpI9DkgPxX8Lg8BMLF9IwL5BIfh%2Fp0cA%2BnmOR3skEGHPwjBwj%2Bd0wH1nhl2VD4a5QRPr1sNo3A4qGM%2FvGoYuz5iLxCC8Odh5978aAdz4DYfSnQKn6thRQOymtL3qK5VORDwAyyD1Sbm%2FavPbWnJPZjBZ6H6tKbuCRGQVkcVmwhb6VQLxQg625H1qzRldu5niAGKhwdgCUYgldn8N6dCDih%2FjCEgw69TuxwY6ngHRZgfuM%2FRER%2B60IvJptDW9jywyW3AaMRNphy0ir1QCFimF9uogcVbkVJxg1clMWI8BTN0f1PcRzyV%2BwerSZbLj0NMhonthwq2zsr7FswaABn7cZd5qA1vfG%2FnuAHegNnPK6UXYFrNDjnYziZoJs%2FdKdgx0oNOAXNbdJrvugLlthyWN5OmWZ8RYsRnJMH3kHyO%2Be49gRg8lDDxCvtUcVQ%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20251024T213616Z&X-Amz-SignedHeaders=host&X-Amz-Credential=ASIAZ4JKJWUV3HUNONFR%2F20251024%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Expires=36000&X-Amz-Signature=ecd06997bd23c88668a2fe7ec0ed9f7677975b672f7283533db8bc6a97744298',
      revisionLocationDifference: {
        moveX: 0,
        moveY: 0,
        factor: 1
      },
      allowSetActive: true,
      overwritePlanname: false,
      coords: [],
      createdBy: 'f579379b-1d64-405f-a0cd-9cd90ebe2763',
      created: '2025-05-08T14:00:30.980Z',
      lastModifiedBy: 'f579379b-1d64-405f-a0cd-9cd90ebe2763',
      lastModified: '2025-05-08T14:00:31.225Z'
    },
    revisions: [],
    active: true,
    s3FolderId: 'd1e2df05-6de8-45c2-a096-2a7c01306168',
    metadata: {
      planType: 'File',
      imageWidth: 800,
      imageHeight: 800,
      fileName: 'airoh1 copy.jpeg',
      contentType: 'image/jpeg',
      checksum: 'f5f91b85efa37881078a332e5cb32195',
      archiveSize: 122880,
      rotation: 0,
      page: -1,
      webpSupported: true,
      tileExtension: 'webp',
      indexedArchive: true
    },
    planType: 'File',
    parentId: 'a26cbc48-658b-4264-8fd1-8f6119243b7b',
    parentName: 'Test',
    permissions: [],
    openTaskCount: 0,
    lastActivity: '2025-10-16T16:19:27.681Z',
    lock: false
  }
]
